import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotifyToastProps } from '@/components/NotifyToast';
import { ViewStates } from '@/models/generics';

export type TokenValidity = 'VALID' | 'INVALID';

export type AppConfig = {
    authFlowViewState: ViewStates;
    notifications: NotifyToastProps[];
    history: string[];
    onLogin?: () => void;
    tokenValidity: TokenValidity;
};

const initialState: AppConfig = {
    authFlowViewState: ViewStates.NOT_VISIBLE,
    notifications: [],
    history: [],
    onLogin: undefined,
    tokenValidity: 'VALID'
};

const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {
        openAuthFlow: (state, action: PayloadAction<(() => void) | undefined>) => {
            state.authFlowViewState = ViewStates.VISIBLE;
            state.onLogin = action.payload;
        },
        closeAuthFlow: (state) => {
            state.authFlowViewState = ViewStates.NOT_VISIBLE;
            state.onLogin = undefined;
        },
        addNotificationToast: (state, action: PayloadAction<NotifyToastProps>) => {
            state.notifications.push(action.payload);
        },
        removeNotificationToast: (state, action: PayloadAction<NotifyToastProps[]>) => {
            state.notifications = action.payload;
        },
        addToAppHistory: (state, action: PayloadAction<string>) => {
            state.history.push(action.payload);
        },
        setTokenInvalid: (state) => {
            state.tokenValidity = 'INVALID';
        }
    }
});

export const {
    openAuthFlow,
    closeAuthFlow,
    addNotificationToast,
    removeNotificationToast,
    addToAppHistory,
    setTokenInvalid
} = appConfigSlice.actions;

export default appConfigSlice.reducer;